import Utils from "../../common/Utils";
export function loadPlaywire() {
    window['tyche'] = { mode: 'tyche', config: '//config.playwire.com/1024053/v2/websites/72250/banner.json' };
    Utils.loadScript('//cdn.intergi.com/hera/tyche.js');
}
